import { render, staticRenderFns } from "./DocumentsMenu.vue?vue&type=template&id=ba869b4a"
import script from "./DocumentsMenu.vue?vue&type=script&lang=js"
export * from "./DocumentsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports